import React from 'react';
import { PhoneIcon } from 'lucide-react';
export function Hero() {
  return <div className="relative w-full h-[600px] md:h-[750px] bg-gray-900 overflow-hidden" data-id="element-54">
      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/jD5r3EywoLpxu3Rbir7n1R/Hurricane-Season.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center bottom',
      backgroundAttachment: 'fixed',
      opacity: 0.7
    }} data-id="element-55"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/70" data-id="element-56"></div>
      <div className="absolute inset-0 flex items-center justify-center px-4" data-id="element-57">
        <div className="text-center max-w-4xl" data-id="element-58">
          <h2 className="text-2xl md:text-6xl font-bold text-white drop-shadow-2xl mb-3 md:mb-4" data-id="element-59">
            HURRICANE SEASON IS HERE!
          </h2>
          <p className="text-lg md:text-3xl text-yellow-400 font-bold mb-4 md:mb-6 drop-shadow-lg" data-id="element-60">
            Is Your Mobile Home Ready?
          </p>
          <h3 className="text-xl md:text-5xl font-bold text-white mb-3 md:mb-4 drop-shadow-lg" data-id="element-61">
            Protect Your Home Before The Storm
          </h3>
          <p className="text-base md:text-2xl text-white mb-6 md:mb-8 drop-shadow-lg" data-id="element-62">
            Schedule Your Hurricane Preparation Inspection Today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6 md:mb-8" data-id="element-63">
            <a href="tel:407-655-9436" className="inline-flex items-center gap-2 md:gap-3 bg-yellow-400 hover:bg-yellow-500 text-black px-6 py-3 md:px-10 md:py-5 text-xl md:text-3xl font-bold rounded-lg transition-colors shadow-2xl" data-id="element-64">
              <PhoneIcon className="w-6 h-6 md:w-8 md:h-8" data-id="element-65" />
              407-655-9436
            </a>
          </div>
          <div className="flex flex-wrap gap-2 md:gap-4 justify-center" data-id="element-66">
            <div className="bg-white text-black px-3 py-2 md:px-6 md:py-3 text-sm md:text-base font-bold rounded shadow-lg" data-id="element-67">
              ✓ Check Loose Straps
            </div>
            <div className="bg-white text-black px-3 py-2 md:px-6 md:py-3 text-sm md:text-base font-bold rounded shadow-lg" data-id="element-68">
              ✓ Add Tie-Downs
            </div>
            <div className="bg-white text-black px-3 py-2 md:px-6 md:py-3 text-sm md:text-base font-bold rounded shadow-lg" data-id="element-69">
              ✓ Replace Ground Anchors
            </div>
            <div className="bg-white text-black px-3 py-2 md:px-6 md:py-3 text-sm md:text-base font-bold rounded shadow-lg" data-id="element-70">
              ✓ Safety Inspection
            </div>
          </div>
        </div>
      </div>
    </div>;
}